@if (initialized) {
    <div class="page-container p-0">
        <!-- Sidebar -->
<!--        [ngClass]="{ 'hidden-sidebar': !showSidebar }"-->
        <aside
               class=" border-200 side-wrap relative pt-2 surface-0"
               [ngClass]="showSidebar ? 'sidebar-panel' : 'w-0rem'">

          <dc-page-hierarchy-tree
                    (emitHierarchyTree)="hierarchyTreeEvent($event)"
                    (selectedNodeChange)="handleSelectedNodeChange($event)"
                    (onNodeContentEntries)="handleNodeContentEntries($event)"
                    (sidebarToggle)="showSidebar = $event"
                    [selectedNode]="selectedNode"
            ></dc-page-hierarchy-tree>
        </aside>

        <!-- Main Content -->
        <section class="content-area p-0">
            <div class="content-body p-0">

<!--                @if (contentEntries && contentEntries.length) {-->

<!--                    @for (content of contentEntries; track content; let i = $index; let count = $count) {-->

<!--                        @if (!editingContentId || editingContentId === content.key) {-->

<!--                            <dc-page-content-->
<!--                                    class="mt-3"-->
<!--                                    [hierarchyTree]="hierarchyTree"-->
<!--                                    [selectedNode]="content"-->
<!--                                    [currentIndex]="i + 1"-->
<!--                                    [totalSections]="count"-->
<!--                                    (editorModeChange)="handleEditorModeChange($event, content)"-->
<!--                            >-->
<!--                            </dc-page-content>-->
<!--                        }-->

<!--                    }-->
<!--                }-->

                @if (contentEntries?.length) {

                    @for (content of contentEntries; track content.objectId; let i = $index; let count = $count) {

                        @if (!editingContentId || editingContentId == content.objectId) {
                            <dc-page-content-object
                                    class="mt-3"
                                    [objectIdentifier]="content"
                                    [currentIndex]="i + 1"
                                    [totalSections]="count"
                                    (editorModeChange)="handleEditorModeChange($event, content)"
                            >
                            </dc-page-content-object>
                        }

                    }
                }
            </div>
        </section>
    </div>
}